import { useState } from 'react';
import { featuredCategories } from '@/mocks/categories';

export default function CategoryGrid() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 text-center">
          Browse Trending Categories
        </h2>
        <p className="mt-3 text-sm text-foreground-500 font-sans text-center">
          Explore the most popular Mulebuy spreadsheet product categories
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {featuredCategories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`relative group overflow-hidden rounded-2xl cursor-pointer transition-all duration-500 ${
                hoveredIndex === index
                  ? 'md:scale-105 md:z-10'
                  : hoveredIndex !== null
                  ? 'md:scale-95 md:opacity-70'
                  : ''
              }`}
              style={{ aspectRatio: '3/4' }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                {cat.tag && (
                  <span className="inline-block px-2.5 py-1 text-xs font-semibold bg-white/90 text-foreground-950 rounded-full mb-2 whitespace-nowrap">
                    {cat.tag}
                  </span>
                )}
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-white">{cat.name}</h3>
                <p className="mt-1 text-sm text-white/70 font-sans opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Browse collection &rarr;
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}